export const API_URL = "https://www.ssbossbazar7.com/xpanel/";
// export const API_URL = 'http://localhost/mtk_result/';

